import styled from 'astroturf/react'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const textColorSecondary4 = 'var(--text-color-secondary-4, rgba(255, 255, 255, 1))'

import { useBooleanState } from 'hooks/useBooleanState'
import { isNoTouchDevice } from 'services/touch_device_detection'

import { TimeButton } from '../../time_button'
import { TimeButtonStyledMarker, TimeButtonTimeDisplay, TimeButtonWrapper } from '../../styles'

import { InviteeCount } from './invitee_count'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/index.js?styleId=Container";


const Container = /*#__PURE__*/styled(TimeButton, null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isNoTouchDevice: isNoTouchDevice()
  })
})

const InviteeCountTimeButton = ({ spot, isSelected, onMouseEnter: onMouseEnterCallback, onMouseLeave: onMouseLeaveCallback, ...props }) => {
  const [isFocused, setFocusTrue, setFocusFalse] = useBooleanState(false)

  const onMouseEnter = (hoveredSpot) => {
    setFocusTrue()
    onMouseEnterCallback(hoveredSpot)
  }

  const onMouseLeave = (hoveredSpot) => {
    setFocusFalse()
    onMouseLeaveCallback(hoveredSpot)
  }

  return (
    <Container
      {...props}
      onMouseEnter={() => onMouseEnter(spot)}
      onMouseLeave={() => onMouseLeave(spot)}
      onFocus={() => setFocusTrue()}
      onBlur={() => setFocusFalse()}
      withMarker={props.hasFreeMarker}
      isSelected={isSelected}
      spot={spot}
    >
      <InviteeCount spot={spot} selected={isSelected} focused={isFocused} />
    </Container>
  )
}

export default InviteeCountTimeButton
